import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as EduContentBookQueries from '../edu-content-book/edu-content-book.selectors';
import { NAME, selectAll, selectEntities, selectIds, selectTotal, State } from './method-style.reducer';

export const selectMethodStyleState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectMethodStyleState, (state: State) => state.error);

export const getLoaded = createSelector(selectMethodStyleState, (state: State) => state.loaded);

export const getAll = createSelector(selectMethodStyleState, selectAll);

export const getCount = createSelector(selectMethodStyleState, selectTotal);

export const getIds = createSelector(selectMethodStyleState, selectIds);

export const getAllEntities = createSelector(selectMethodStyleState, selectEntities);

export const getByEduContentBookId = (eduContentBookId: number) =>
  createSelector(getAll, (entities) => entities.find((entity) => entity.eduContentBookId === eduContentBookId));

// Book-scoped override row wins; method default is the fallback.
export const getMethodStyleForBook = (bookId: number) =>
  createSelector(getAll, EduContentBookQueries.getAllEntities, (styles, books) => {
    const override = styles.find((s) => s.eduContentBookId === bookId);
    if (override) return override;
    const methodId = books[bookId]?.methodId;
    if (methodId == null) return undefined;
    return styles.find((s) => s.methodId === methodId && s.eduContentBookId == null);
  });

export const isBookLoaded = (props: { bookId: number }) =>
  createSelector(selectMethodStyleState, (state: State) => !!state.loadedForBook[props.bookId]);
